var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4028 11.142C14.0068 10.5002 14.0068 9.49915 13.4028 8.8574L7.27366 2.34521C6.95823 2.01006 6.43084 1.99408 6.09569 2.30951C5.76055 2.62494 5.74457 3.15234 6.06 3.48748L12.1891 9.99968L6.06 16.5119C5.74457 16.847 5.76055 17.3744 6.09569 17.6898C6.43084 18.0053 6.95824 17.9893 7.27367 17.6541L13.4028 11.142Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNext);
export default __webpack_public_path__ + "static/media/ic_next.ce8a1899a9602011d7a5aaf0a0eef1b4.svg";
export { ForwardRef as ReactComponent };